import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../service/authProvider";
import { useSelectedOrgId } from "../../hooks/useSelectedOrgId";

function ProtectedRoute({ children }) {
  //Save the current location they were
  // trying to go to when they were redirected.
  let location = useLocation();

  const isAuthenticated = useAuth();
  const [selectedOrgId] = useSelectedOrgId();

  if (!isAuthenticated) {
    // Redirect them to the /login page,
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (
    isAuthenticated &&
    !selectedOrgId &&
    window.location.pathname !== "/choose"
  ) {
    // Redirect them to the /choose page,
    return <Navigate to="/choose" state={{ from: location }} />;
  }

  return children;
}

export default ProtectedRoute;
